import { Box, Flex, Paper, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { get } from 'lodash';

import { NumberInput, Tooltip } from '@components';
import { EVALUATION_WEB_VALUE_PERCENTAGE_FACTOR } from '@constants';
import { toDecimal } from '@utils';
import { renderActiveMethodButton } from './CustomerViewEvaluationMethods';
import classes from './CustomerViewEvaluationMethods.module.css';
import { CustomerViewEvaluationMethodsFormValues } from './useCustomerViewEvaluationMethodsFormInitializer';

interface CustomerViewEvaluationMethodWebValueProps {
  form: UseFormReturnType<CustomerViewEvaluationMethodsFormValues>;
}

export const CustomerViewEvaluationMethodWebValue: React.FC<CustomerViewEvaluationMethodWebValueProps> = ({ form }) => {
  const { evaluationMethods } = form.values;

  const globalError = get(form.errors, 'evaluationMethods.evalMethodWebValue.globalError');

  return (
    <Paper
      className={`${classes.evaluationMethodContainer} ${
        globalError ? classes.hasError : evaluationMethods.evalMethodWebValue?.activateMethod || false ? classes.activeMethod : ''
      }`}
    >
      <Flex>
        <Box className={classes.evaluationMethodContainerHeaderBody}>
          <Text fz={14} mb={10}>
            EvalMethod Web Value
          </Text>
        </Box>
        {renderActiveMethodButton(form, evaluationMethods.evalMethodWebValue?.activateMethod || false, 'evaluationMethods.evalMethodWebValue.activateMethod')}
      </Flex>

      <Box className={classes.evaluationMethodFormRow} pt={25} pb={30}>
        <NumberInput
          {...form.getInputProps('evaluationMethods.evalMethodWebValue.minimumRate')}
          label="Minimum rate (%)"
          onChange={(value) => {
            form.setFieldValue('evaluationMethods.evalMethodWebValue.minimumRate', Number(value) / EVALUATION_WEB_VALUE_PERCENTAGE_FACTOR);
          }}
          value={toDecimal(Number(evaluationMethods.evalMethodWebValue?.minimumRate) * EVALUATION_WEB_VALUE_PERCENTAGE_FACTOR)}
        />
        <Tooltip content="Minimum rate (%) = invoiced value (€ / kg) / resale value (€/kg)" />
      </Box>

      {!!globalError && <Box className={classes.error}>{globalError}</Box>}
    </Paper>
  );
};
